import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'venus', 'Venus', [["path",{"d":"M7 9a5 5 0 1 0 10 0a5 5 0 1 0 -10 0"}],["path",{"d":"M12 14l0 7"}],["path",{"d":"M9 18l6 0"}]]);